import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.object.entries";
import "core-js/modules/es6.array.for-each";

var spacingFunction = function spacingFunction(spacingType, direction, rhythmUnits, breakpoint, mediaBreakpoints) {
  var spacingCss = '';
  Object.entries(breakpoint).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        breakpointKey = _ref2[0],
        breakpointValue = _ref2[1];

    var rule = "".concat(spacingType, "-").concat(direction, ": ").concat((breakpointValue.base * breakpointValue.lineHeight * rhythmUnits).toFixed(4), "rem;\n");

    if (breakpointKey === 'default') {
      spacingCss += rule;
    } else {
      spacingCss += "".concat(mediaBreakpoints[breakpointKey](rule), "\n");
    }
  });
  return spacingCss;
};

var generateSpacingMixins = function generateSpacingMixins(breakpoint, mediaBreakpoints) {
  var margin = function margin(direction, rhythmUnits) {
    return spacingFunction('margin', direction, rhythmUnits, breakpoint, mediaBreakpoints);
  };

  var padding = function padding(direction, rhythmUnits) {
    return spacingFunction('padding', direction, rhythmUnits, breakpoint, mediaBreakpoints);
  };

  return [margin, padding];
};

export { generateSpacingMixins };